'use strict';

var cov_1fsjzs5pdf = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/mediaDetails/mediaDetails.js',
        hash = '3cfeb24712e1f3bc4a4c34ee3bb3c7a6bf82b174',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/mediaDetails/mediaDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 8,
                    column: 3
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_1fsjzs5pdf.s[0]++;
angular.module('app').component('mediaDetails', {
    templateUrl: 'app/components/mediaDetails/mediaDetails.html',
    bindings: {
        media: '<'
    }
});